// Visitor language choice for public Calendar pages: the same 13 languages as leadya.ai.
// The cookie holds a native Cal.diy locale code; leadya.ai aliases (cz, ua, zh) are accepted on input.
const LOCALE_COOKIE = "leadya_calendar_locale";
const LANGUAGES = [
  { code: "pl", name: "Polski", label: "Język" },
  { code: "en", name: "English", label: "Language" },
  { code: "fr", name: "Français", label: "Langue" },
  { code: "de", name: "Deutsch", label: "Sprache" },
  { code: "es", name: "Español", label: "Idioma" },
  { code: "cs", name: "Čeština", label: "Jazyk" },
  { code: "uk", name: "Українська", label: "Мова" },
  { code: "ru", name: "Русский", label: "Язык" },
  { code: "it", name: "Italiano", label: "Lingua" },
  { code: "bg", name: "Български", label: "Език" },
  { code: "zh-CN", name: "简体中文", label: "语言" },
  { code: "ja", name: "日本語", label: "言語" },
  { code: "ro", name: "Română", label: "Limbă" },
];
const ALIASES = { cz: "cs", ua: "uk", zh: "zh-CN" };

/** Returns the supported Cal.diy locale for a code or alias, or null for anything else. */
function normalizeLocale(value) {
  if (typeof value !== "string") return null;
  const lower = value.trim().toLowerCase();
  if (Object.prototype.hasOwnProperty.call(ALIASES, lower)) return ALIASES[lower];
  const language = LANGUAGES.find((candidate) => candidate.code.toLowerCase() === lower);
  return language ? language.code : null;
}

/** Reads the choice from a plain cookie record or a Next.js cookie store; invalid values are ignored. */
function readLocaleCookie(cookies) {
  if (!cookies || typeof cookies !== "object") return null;
  const entry = typeof cookies.get === "function" ? cookies.get(LOCALE_COOKIE) : cookies[LOCALE_COOKIE];
  return normalizeLocale(typeof entry === "string" ? entry : entry && entry.value);
}

/** Label of the language selector in the given locale, English when unknown. */
function languageLabel(locale) {
  const language = LANGUAGES.find((candidate) => candidate.code === normalizeLocale(locale));
  return language ? language.label : "Language";
}

/** The visitor's explicit choice read in the browser; null on the server or without a choice. */
function readBrowserLocale() {
  if (typeof document === "undefined" || typeof document.cookie !== "string") return null;
  const entry = document.cookie.split(";").map((part) => part.trim()).find((part) => part.indexOf(LOCALE_COOKIE + "=") === 0);
  if (!entry) return null;
  try {
    return normalizeLocale(decodeURIComponent(entry.slice(LOCALE_COOKIE.length + 1)));
  } catch (_) {
    return null;
  }
}

/** Translated title for the locale (exact code or its base language), or null when none fits. */
function translatedTitle(translations, locale) {
  if (!Array.isArray(translations) || typeof locale !== "string" || !locale) return null;
  const base = locale.split("-")[0];
  const match = translations.find((entry) => entry && entry.targetLocale === locale)
    || translations.find((entry) => entry && entry.targetLocale === base);
  return match ? match.translatedText : null;
}

module.exports = { LOCALE_COOKIE, LANGUAGES, normalizeLocale, readLocaleCookie, readBrowserLocale, translatedTitle, languageLabel };
